var _rect, _rect2, _polygon, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 16,
    height: 10,
    stroke: "#333333",
    strokeWidth: 2,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 2,
    height: 5,
    stroke: "#333333",
    strokeWidth: 2,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2,8 5,5 8,8 11,5 14,8 18,8",
    stroke: "#333333",
    strokeWidth: 2,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 2,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 2,
    height: 2,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 2,
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 2,
    height: 2,
    fill: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 2,
    height: 2,
    fill: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 2,
    height: 2,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduction);
export default __webpack_public_path__ + "static/media/icon_production.b9e139ba87b621203fea5bea57ec1c5d.svg";
export { ForwardRef as ReactComponent };